/**
 * Typed Redux hooks
 * Use throughout the app instead of plain `useDispatch` and `useSelector`
 */

import { useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from '@/store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
